import { SectionType } from './landing-page';
import { Log } from './log';

export interface AppSettings extends Log {
    id?: any;
    searchCategories: SettingsSearchCategory[];
    landingPage: SettingLandingPage;
    specialUrls: SettingsSpecialUrls;
    otherSettings: SettingsOtherSettings;
    boutiqueImageUrl: string;
    sellNowUrl: string;
    isActive: boolean;
}

export interface SettingsSearchCategory {
    wooId: number;
    showOnSearch: boolean;
    showWithImage: boolean;
    searchOrder: number;
    imageOrder: number;
    alternateName: string;
    hideSubcategoriesInSearch: boolean;
}

export interface SettingLandingPage {
    sections: SettingsSection[];
}

export interface SettingsSection {
    type: SectionType;
    title: string;
    subTitle: string;
    callToActionButtonText?: string;
    tag?: string;
    imageUrl?: string;
    categoryToNavigate?: string;
    numberOfArticles?: number;
    products?: string[];
    externalUrl?: string;
    category?: string;
    quote?: string;
}

export interface SettingsSpecialUrls {
    favoritesImage: string;
    accountImage: string;
}

export interface SettingsOtherSettings {
    contactPhoneNumber: string;
}
